import AppMenu from "../../AppMenu/Components/AppMenu";
import TopNavigation from "./TopNavigation";

export default function AuthenticatedLayout({ children, screenSizeClass }) {
  return (
    <>
      <div className={`animate__animated animate__fadeInDown top-bar ${screenSizeClass}`}>
        <TopNavigation />
      </div>
      <AppMenu />
      <div
        className={`animate__animated animate__fadeInDown content ${screenSizeClass} position-absolute top-0 start-0`}
      >
        {children}
      </div>
    </>
  );
}
